import { useLocation } from "react-router-dom";
import { useAnalytics } from "../lib/analytics/analytics";
import { Fragment, useEffect } from "react";
import React from "react";
import { useFlexspaceAnalytics } from "../offering/flexspace/flexspace_analytics";
import { useCMDashboardAnalytics } from "../offering/flexspace/cm_dashboard_analytics";
import { useThePortalAnalytics } from "../offering/flexspace/the_portal_analytics";

export function AppTracker() {
  const analytics = useAnalytics();
  const location = useLocation();
  const currentPathname = location.pathname;

  useEffect(() => {
    // this will not work for the first time when analytic clients is not yet loaded
    // but will work the next time when navigating around.
    const clients = Object.values(analytics.integration).filter(
      (p) => p.sendPageView
    );
    clients.forEach((client) => client.screen());
  }, [analytics, currentPathname]);

  return <Fragment />;
}

interface ProviderProps {
  children: React.ReactNode;
}
export function FlexspaceAnalyticsProvider(props: ProviderProps) {
  const { children } = props;
  useFlexspaceAnalytics();

  return <Fragment>{children}</Fragment>;
}

export function CMDashboardAnalyticsProvider(props: ProviderProps) {
  const { children } = props;
  useCMDashboardAnalytics();

  return <Fragment>{children}</Fragment>;
}

export function ThePortalAnalyticsProvider(props: ProviderProps) {
  const { children } = props;
  useThePortalAnalytics();

  return <Fragment>{children}</Fragment>;
}
